import User from "@components/user-modal/components/models/User";
import AppAccessSection from "@components/user-modal/components/sections/AccessSection";
import AppAddressSection from "@components/user-modal/components/sections/AddressSection";
import AppContactSection from "@components/user-modal/components/sections/ContactSection";
import AppGeneralSection from "@components/user-modal/components/sections/GeneralSection";
import AppMasterUserSection from "@components/user-modal/components/sections/MasteUserSection";
import AppTagsSection from "@components/user-modal/components/sections/TagsSection";
import AppTogglesSection from "@components/user-modal/components/sections/TogglesSection";
import AppUserModalFooter from "@components/user-modal/components/UserModalFooter";
import EventBus from "@packages/event-bus";
import Case from "case";
import _ from "lodash";

export default {
    components: {
        AppAccessSection,
        AppAddressSection,
        AppUserModalFooter,
        AppContactSection,
        AppGeneralSection,
        AppTogglesSection,
        AppTagsSection,
        AppMasterUserSection
    },

    data() {
        return {
            step: null,
            edit: null,
            form: this.getDefaultForm(),
            entity: null
        };
    },

    props: {},

    computed: {
        isEstablishment() {
            return this.entity === "establishments";
        },
        isPartners() {
            return this.entity === "partners";
        },
        isAdmin() {
            return this.$store.state.users.admin && !this.$store.state.users.user;
        },
        isLoggedPartner() {
            return this.$store.state.users.user && this.$store.state.users.user.tipo === "PARCEIRO" 
        },
    },

    methods: {
        async submit() {
            const isValid = await this.$validator.validateAll();

            if(this.isEstablishment && !this.form.general.useType) {
                return EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: 'O campo Tipo é obrigatório',
                });
            }

            if (isValid) {
                const func = this.edit ? "update" : "create";

                await this.$api[this.entity][func](this.form);

                EventBus.$emit(`LOAD_${Case.upper(this.entity)}`);
                EventBus.$emit("LOAD_DATA","");
                this.$emit("close");
            }
        },

        reset({ entity, user }) {
            this.step = 1;
            this.edit = !!user;
            this.form = user ? user : this.getDefaultForm();
            this.entity = entity;
        },

        getDefaultForm() {
            const defaultUser = _.cloneDeep(User);

            if (!this.edit) {
                if (this.isLoggedPartner) {
                defaultUser.permissions = this.setPartnerManageablePermissionsAsActive();
                }

                if (this.isAdmin) {
                defaultUser.permissions.push('MANAGE_LOCALS');
                }
            }

            return defaultUser;
        },

        setPartnerManageablePermissionsAsActive() {
            const requiredPermissions = [
                { key: 'MANAGE_LOCALS', label: 'Gerenciar Locais' },
                { key: 'CREATE_CAMPAIGN', label: 'Criar Campanha' }
            ];

            const map = new Map();

            this.permissions.forEach((permission) => {
                map.set(permission.key, permission);
            });

            requiredPermissions.forEach((permission) => {
                map.set(permission.key, permission);
            });

            return Array.from(map.keys());
        }
    },

    mounted() {
        EventBus.$on("RESET_USER_MODAL", this.reset);
    },

    beforeDestroy() {
        EventBus.$off("RESET_USER_MODAL", this.reset);
    }
};
